module.exports = __webpack_public_path__ + "static/coph4-d5e60ed7a57cdcc8f6fd8aa7d9f648f8.jpg";